import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProxyLoginContext } from '../contexts/ProxyLoginContext';
import { isProxyRestrictedPath } from '../constants/proxyLogin';
import { PROXY_LOGIN_RESTRICTED_MESSAGE } from '../constants/labels';

type UseProxyAccessControlReturn = {
  isRestricted: boolean;
  errorMessage: string | null;
};

/**
 * 代理モード中の画面アクセス制御フック
 * 禁止画面にアクセスした場合はホームにリダイレクトし、エラーメッセージを返す
 */
export const useProxyAccessControl = (): UseProxyAccessControlReturn => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isProxyLogin } = useContext(ProxyLoginContext);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const isRestricted = isProxyLogin && isProxyRestrictedPath(location.pathname);

  useEffect(() => {
    if (isRestricted) {
      setErrorMessage(PROXY_LOGIN_RESTRICTED_MESSAGE);
      navigate('/home');
    } else {
      setErrorMessage(null);
    }
  }, [isRestricted, navigate]);

  return {
    isRestricted,
    errorMessage,
  };
};
